import * as React from 'react'
import { TextBlock } from '@amzn/dvui/dist/TextBlock'
import * as st from './notificationAction.module.scss'
import { ConditionalText } from '../../utils/conditionalText'
import * as hoverClasses from '../../widgets/Hover/hoverComponent.module.scss'

export interface ITextBlockNotificationProps {
  messages?: string[]
}

export const TextBlockNotification = ({ messages }: ITextBlockNotificationProps) => {
  if (!messages || !messages.length) {
    return null
  }
  // TODO: AVWebDetailPage-1831
  return (
    <>
      { messages.map((message, idx) => (
          <ConditionalText key={idx} Tag={TextBlock} className={`${st.notificationBox} ${hoverClasses.buttonOverride}`} message={message} />
        ))}
    </>
  )
}
